<template>
  <div class="home">
    <!-- <div v-if="innerWidth > 1000"> -->
      <HomePc ref="homePc"></HomePc>
    <!-- </div> -->
    <!-- <div v-else>
      <HomeM></HomeM>
    </div> -->
  </div>
</template>

<script>
// import {editUserPwd} from "@/api/user";
// @ is an alias to /src
import HomePc from "./components/home_pc.vue";
// import HomeM from "./components/home_m.vue"; // 已移除移动端组件
import { mapState } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {};
  },
  mounted() {
    //console.log('🏠 Home.vue mounted - 页面刷新检测');
    // 确保子组件能正确初始化
    this.$nextTick(() => {
      //console.log('🏠 Home.vue nextTick完成');
      // 通知子组件进行初始化
      this.$refs.homePc && this.$refs.homePc.handleParentMounted && this.$refs.homePc.handleParentMounted();
    });
  },
  computed: {
    ...mapState(["innerWidth"]),
  },
  components: {
    HomePc,
    // HomeM, // 已移除移动端组件
  },
};
</script>
